module.exports = __webpack_public_path__ + "img/stock6.1ba04a58.png";